import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=ed061df2&scoped=true&"
import script from "./Dynamic.vue?vue&type=script&lang=js&"
export * from "./Dynamic.vue?vue&type=script&lang=js&"
import style0 from "./Dynamic.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Dynamic.vue?vue&type=style&index=1&id=ed061df2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed061df2",
  null
  
)

export default component.exports